import { Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LogServiceCamera from '../../components/LogServiceCamera';

export const ServicesModal = ({
  title,
  isVisible,
  handleOk,
  handleCancel,
  data,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('Services') + ` (${title})` ?? ''}
      className="modal-service-camera"
      style={{ top: 64 }}
      visible={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="85%"
      footer={false}
    >
      <LogServiceCamera dataDevice={data} />
    </Modal>
  );
};
